import EventBus from 'EventBus';
import { faro } from '@gate31/faro/src';
import { Gate31ApiV2 } from '@gate31/core/src/api/gate31-api';
import { Base } from '@gate31/core/src/libs/BaseComponent';
import { CustomCn } from '@gate31/core/src/libs/classname';

export class ConfirmPhone extends Base<HTMLElement> {
    cn: CustomCn;

    confirmed: boolean;
    $phoneWrapper: HTMLDivElement;
    $phoneField: HTMLInputElement;
    $phoneBtn: HTMLButtonElement;
    $phoneError: HTMLDivElement;
    $phoneCodeWrapper: HTMLDivElement;
    $phoneCodeField: HTMLInputElement;
    $phoneCodeBtn: HTMLButtonElement;
    $phoneCodeError: HTMLDivElement;
    $successIcon: HTMLDivElement;
    $resetBtn: HTMLSpanElement;
    $getBtn: HTMLSpanElement;

    constructor(opts: { node: HTMLElement; cn: CustomCn }) {
        super(opts.node);

        this.confirmed = false;
        this.cn = opts.cn;

        if (! this.getRoot()) {
            return;
        }

        this.$phoneWrapper = this.getRoot().querySelector<HTMLDivElement>(this.cn.setElem('phone-wrapper').toSelector()) as HTMLDivElement;
        this.$phoneField = this.getRoot().querySelector<HTMLInputElement>(this.cn.setElem('phone-field').toSelector()) as HTMLInputElement;
        this.$phoneBtn = this.getRoot().querySelector<HTMLButtonElement>(this.cn.setElem('phone-trigger').toSelector()) as HTMLButtonElement;
        this.$phoneError = this.getRoot().querySelector<HTMLDivElement>(this.cn.setElem('phone-error').toSelector()) as HTMLDivElement;
        this.$phoneCodeWrapper = this.getRoot().querySelector<HTMLDivElement>(this.cn.setElem('wrapper-phone-code').toSelector()) as HTMLDivElement;
        this.$phoneCodeField = this.getRoot().querySelector<HTMLInputElement>(this.cn.setElem('phone-code-field').toSelector()) as HTMLInputElement;
        this.$phoneCodeBtn = this.getRoot().querySelector<HTMLButtonElement>(this.cn.setElem('phone-code-trigger').toSelector()) as HTMLButtonElement;
        this.$phoneCodeError = this.getRoot().querySelector<HTMLDivElement>(this.cn.setElem('phone-code-error').toSelector()) as HTMLDivElement;
        this.$successIcon = this.getRoot().querySelector<HTMLDivElement>(this.cn.setElem('success-icon').toSelector()) as HTMLDivElement;
        this.$resetBtn = this.getRoot().querySelector<HTMLSpanElement>(this.cn.setElem('reset').toSelector()) as HTMLDivElement;
        this.$getBtn = this.getRoot().querySelector<HTMLSpanElement>(this.cn.setElem('get').toSelector()) as HTMLDivElement;

        this.callbackConnection();
    }

    callbackConnection() {
        // Отправка номера для получения кода
        this.$phoneBtn.addEventListener('click', () => {
            this.resetFieldPhoneCode();

            this.getCode()
                .then(() => {
                    this.lockGetBtn();
                })
                .catch(() => {
                    this.unablePhoneBtn();
                });
        });

        // Отправка кода подтверждения
        this.$phoneCodeBtn.addEventListener('click', () => {
            this.sendCode();
        });

        // Сброс номера телефона
        this.$resetBtn.addEventListener('click', () => {
            this.unablePhoneBtn();
            this.openPhoneBtn();
            this.unablePhoneField();
            this.hiddenPhoneCode();
            this.hiddenSuccessIcon();

            this.confirmed = false;
        });

        // Повторный запрос кода
        this.$getBtn.addEventListener('click', () => {
            this.getCode();
            this.lockGetBtn();
        });

        this.$phoneField.addEventListener('input', () => {
            this.removePhoneError();
        });

        this.$phoneCodeField.addEventListener('input', () => {
            this.removePhoneCoreError();
            this.removePhoneError();
        });

        EventBus.subscribe('confirm-phone:get-code', () => {
            this.disablePhoneBtn(); // Убрать кнопку подтверждения
            this.disabledPhoneField();
            this.openPhoneCode(); // Показать поле для кода
            this.openGetButton();
            this.openPhoneCodeField();
        });
        EventBus.subscribe('confirm-phone:send-code', () => {
            this.openSuccessIcon();
            this.hiddenPhoneBtn();

            this.hiddenGetButton();
            this.hiddenPhoneCodeField();

            this.removePhoneCoreError();
            this.removePhoneError();

            this.confirmed = true;
        });

        this.$phoneField.addEventListener('input', () => {
            const notPointerClass = this.cn.setElem('btn-not-pointer').toString();

            if (this.$phoneField.value) {
                this.$phoneBtn.classList.remove(notPointerClass);
            } else {
                this.$phoneBtn.classList.remove(notPointerClass);
            }
        });

        this.$phoneCodeField.addEventListener('input', () => {
            const notPointerClass = this.cn.setElem('btn-not-pointer').toString();

            if (this.$phoneCodeField.value) {
                this.$phoneCodeBtn.classList.remove(notPointerClass);
            } else {
                this.$phoneCodeBtn.classList.remove(notPointerClass);
            }
        });
    }

    private openPhoneCodeField() {
        this.$phoneCodeField.classList.remove('hidden');
        this.$phoneCodeBtn.classList.remove('hidden');
    }

    private hiddenPhoneCodeField() {
        this.$phoneCodeField.classList.add('hidden');
        this.$phoneCodeBtn.classList.add('hidden');
    }

    private openGetButton() {
        this.$getBtn.classList.remove('hidden');
    }

    private hiddenGetButton() {
        this.$getBtn.classList.add('hidden');
    }

    private lockGetBtn() {
        let timer = 59;
        const defaultText = this.$getBtn.innerText;

        this.disablePhoneBtn();
        this.$getBtn.setAttribute('disabled', '');

        const intervalId = setInterval(() => {
            timer -= 1;

            const $getBtnContent = this.$getBtn.querySelector<HTMLSpanElement>('span');

            if (! $getBtnContent) {
                throw new Error('Ошибка в отрисовки таймера повторной отправки');
            }

            $getBtnContent.innerHTML = `Отправить повторно через ${timer} сек.`;

            if (timer <= 0) {
                $getBtnContent.innerHTML = defaultText;
                this.$getBtn.removeAttribute('disabled');
                this.unablePhoneBtn();
                clearInterval(intervalId);
            }
        }, 1000);
    }

    private unablePhoneField() {
        this.$phoneField.removeAttribute('disabled');
    }

    private disabledPhoneField() {
        this.$phoneField.setAttribute('disabled', '');
    }

    private hiddenPhoneBtn() {
        this.$phoneBtn.classList.add('hidden');
    }

    private openPhoneBtn() {
        this.$phoneBtn.classList.remove('hidden');
    }

    private openSuccessIcon() {
        this.$successIcon.classList.remove('hidden');
    }

    private hiddenSuccessIcon() {
        this.$successIcon.classList.add('hidden');
    }

    private unablePhoneBtn() {
        this.$phoneBtn.removeAttribute('disabled');
    }

    private disablePhoneBtn() {
        this.$phoneBtn.setAttribute('disabled', '');
    }

    private openPhoneCode() {
        this.$phoneCodeWrapper.classList.remove('hidden');
    }

    private hiddenPhoneCode() {
        this.$phoneCodeWrapper.classList.add('hidden');
    }

    resetFieldPhoneCode() {
        this.$phoneCodeField.value = '';
    }

    renderNotConfirmError() {
        this.renderError({
            $field: this.$phoneError,
            error: 'Номер телефона необходимо подтвердить'
        });
    }

    private renderError({ error, $field }: { error: string; $field: HTMLElement }) {
        $field.innerHTML = error;
        $field.classList.add('active');
    }

    removePhoneError() {
        this.$phoneError.classList.remove('active');
    }

    removePhoneCoreError() {
        this.$phoneCodeError.classList.remove('active');
    }

    /**
     * Отправить код в смс
     */
    async getCode() {
        await window?.smartCaptcha?.executePromise?.();

        const phone = this.$phoneField.value;
        const input = document.querySelector('#captcha-container input') as HTMLInputElement;
        const token = input.value;

        if (! token) {
            this.renderError({ $field: this.$phoneError, error: 'Подтвердите, что вы не робот' });
            return Promise.reject();
        }

        return Gate31ApiV2.configPhoneGetCode(phone, token)
            .then(response => {
                if (! response.status || response.status !== 'success') {
                    throw response;
                }

                EventBus.publish('confirm-phone:get-code', response);
            })
            .catch(error => {
                try {
                    faro.api.pushError(error, {
                        context: {
                            apiMethod: 'getCode',
                            component: 'ConfirmPhone',
                            jsonError: JSON.stringify(error)
                        }
                    });
                } catch (e) {
                    faro.api.pushError(error, {
                        context: {
                            apiMethod: 'getCode',
                            component: 'ConfirmPhone'
                        }
                    });
                }

                switch (error.code) {
                    case 'INVALID_PHONE':
                        this.renderError({
                            $field: this.$phoneError,
                            error: 'Укажите корректный номер телефона'
                        });
                        break;
                    case 'INVALID_PHONE_COUNTRY_CODE':
                        this.renderError({
                            $field: this.$phoneError,
                            error: 'Для регистрации аккаунта на иностранные номера обратитесь в поддержку'
                        });
                        break;
                    case 'TOO_MANY_REQUESTS':
                        this.renderError({
                            $field: this.$phoneError,
                            error: 'Повторная отправка кода возможна через 60 секунд'
                        });
                        break;
                    case 'CAPTCHA_FAILED':
                        this.renderError({
                            $field: this.$phoneError,
                            error: 'Похоже вы робот... Попробуйте снова через 60 секунд'
                        });
                        break;
                    default:
                        this.renderError({
                            $field: this.$phoneError,
                            error: 'Ошибка при отправке. Повторите попытку'
                        });
                        break;
                }

                throw error;
            });
    }

    /**
     * Отправить код подтверждения
     */
    sendCode() {
        const code = this.$phoneCodeField.value;
        const phone = this.$phoneField.value;

        Gate31ApiV2.configPhoneSendCode({ phone, code })
            .then(response => {
                if (! response.status || response.status !== 'success') {
                    throw response;
                }

                EventBus.publish('confirm-phone:send-code', response);
            })
            .catch(error => {
                try {
                    faro.api.pushError(error, {
                        context: {
                            apiMethod: 'sendCode',
                            component: 'ConfirmPhone',
                            jsonError: JSON.stringify(error)
                        }
                    });
                } catch (e) {
                    faro.api.pushError(error, {
                        context: {
                            apiMethod: 'sendCode',
                            component: 'ConfirmPhone'
                        }
                    });
                }

                this.renderError({
                    $field: this.$phoneCodeError,
                    error: 'Неверный код или превышено время ожидания'
                });
            });
    }
}
